import { render } from "./BookshelfItem.vue?vue&type=template&id=65976957&scoped=true"
import script from "./BookshelfItem.vue?vue&type=script&lang=js"
export * from "./BookshelfItem.vue?vue&type=script&lang=js"

import "./BookshelfItem.vue?vue&type=style&index=0&id=65976957&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65976957"]])

export default __exports__